/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useMemo, useState } from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { Avatar, message } from 'antd-v5';
import { EditOutlined } from '@ant-design/icons';
import QuickViewCard from '../../components/QuickViewCard';
import { APPOINTMENTS_STATUS, updateAppointment } from '../../../../../../services/appointments';
import { AssignAssociatesModal } from '../../../../../Layout/AssignAssociatesModal';
import { BadgeStatus } from '../../../../Today/Appointments/BadgeStatus';

const AppointmentCard = ({
  id,
  appointmentDate,
  appointmentType,
  store,
  status,
  allAssoc,
  note,
  associate,
  source,
  onAssignedSuccess = () => { },
  handleEdit = () => { },
  appointmentsConfig = {},
}) => {
  const [showAssignModal, setShowAssignModal] = useState(false);

  const handleCloseAssignModal = useCallback(() => {
    setShowAssignModal(false);
  }, []);

  const handleAssign = useCallback(
    async associateId => {
      try {
        await updateAppointment(
          id,
          {
            associateId,
            status: 'ASSIGNED',
          },
          true,
        );
        onAssignedSuccess();
        message.success(`Appointment${id ? '' : 's'} assigned successfully`);
        handleCloseAssignModal();
      } catch (error) {
        console.error('Error assigning appointments:', error);
        message.error('Error assigning appointments');
      }
    },
    [onAssignedSuccess, id],
  );

  const date = useMemo(() => {
    const appStore = appointmentsConfig.stores?.find(app => app.id === store.id);
    return formatInTimeZone(appointmentDate, appStore?.timezone, 'h:mmaaa MMM dd, yyyy');
  }, [appointmentDate, appointmentsConfig.stores]);

  const isEditable = useMemo(() => {
    return ![APPOINTMENTS_STATUS.COMPLETED, APPOINTMENTS_STATUS.CANCELED, APPOINTMENTS_STATUS.NO_SHOW].includes(
      status.code,
    );
  }, [status.code]);

  const sourceText = useMemo(() => {
    switch (source) {
      case 'ASSOCIATE':
        return 'Booked in App';
      case 'CLIENT':
        return 'Booked in Kiosk';
      default:
        return null;
    }
  }, [source]);

  return (
    <QuickViewCard
      borderColor="#774FA4"
      onClick={!showAssignModal && isEditable ? handleEdit : null}
      title={`${date} - ${store?.name || ''}`}
      titleDescription={<BadgeStatus status={status} />}
      titleSubtext={sourceText}
      action={
        <div
          className={`flex-row items-center gap-8 ${isEditable ? 'pointer' : ''}`}
          style={{ color: '#7F7F7F80', '&:hover': { color: '#3D3D3D' } }}
          onClick={
            isEditable
              ? e => {
                e.stopPropagation();
                setShowAssignModal(true);
              }
              : null
          }
        >
          <EditOutlined />
          {associate?.id && (
            <Avatar style={{ verticalAlign: 'middle' }} gap={3} size={20} src={associate.image}>{`${associate?.firstName?.charAt(0) || ''
              }${associate?.lastName?.charAt(0) || ''}`}</Avatar>
          )}
          {associate?.id ? `${associate.firstName || ''} ${associate.lastName || ''}` : 'Assign Appointment'}
        </div>
      }
    >
      {appointmentType?.name && (
        <span className="fs-13 m-top-8" style={{ color: '#00000066' }}>
          {appointmentType?.name}
        </span>
      )}
      {note && (
        <span
          className="fs-13 m-top-8 note-clamp"
          style={{
            color: '#00000066',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxHeight: '2.8em',
            whiteSpace: 'normal',
            textAlign: 'left',
          }}
          title={note}
        >
          {note}
        </span>
      )}
      {showAssignModal && (
        <AssignAssociatesModal
          allAssoc={allAssoc.filter(assoc => assoc.store_ids.includes(store.id))}
          isOpen={showAssignModal}
          onAssign={handleAssign}
          onClose={() => setShowAssignModal(false)}
        />
      )}
    </QuickViewCard>
  );
};

export default AppointmentCard;
